"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSearchMfeUrl = void 0;
const buildSearchMfeUrl = (params) => {
    const paramsString = params.toString();
    return `/search?${paramsString}`;
};
exports.buildSearchMfeUrl = buildSearchMfeUrl;
//# sourceMappingURL=buildSearchMfeUrl.js.map